export const H1_FONT_SIZE = '4rem';
export const H2_FONT_SIZE = '3rem';
export const NORMAL_FONT_SIZE = '2rem';
